import React from "react";
import { useAuth } from "@/context/AuthContext";
import PrivateDashboard from "@/pages/dashboard/PrivateDashboard";
import CarrierDashboard from "@/pages/dashboard/CarrierDashboard";
import AdminDashboard from "@/pages/dashboard/AdminDashboard";
import { Navbar } from "@/components/Navbar";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "admin") return <AdminDashboard />;
  if (user.role === "carrier") return <CarrierDashboard />;
  return <PrivateDashboard />;
}

export function DashboardShell({ title, subtitle, children, actions }) {
  return (
    <div className="App bg-background min-h-screen">
      <Navbar />
      <div className="mx-auto max-w-7xl px-6 py-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
          <div>
            <p className="label-eyebrow text-accent">Pannello di controllo</p>
            <h1 className="font-display font-bold tracking-tight text-3xl md:text-4xl mt-2">{title}</h1>
            {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
          </div>
          {actions}
        </div>
        {children}
      </div>
    </div>
  );
}
